const Group = () => (
  <div className="flex items-center">
    {[0, 1, 2].map((i) => (
      <span key={i} className="flex items-center whitespace-nowrap">
        <span className="px-6 font-display text-4xl font-bold uppercase tracking-tight text-ink md:px-10 md:text-6xl">
          Built for what comes next
        </span>
        <span className="text-ember" aria-hidden="true">
          ✳
        </span>
        <span className="text-outline px-6 font-display text-4xl font-bold uppercase tracking-tight md:px-10 md:text-6xl">
          AKLIVE
        </span>
        <span className="text-ember" aria-hidden="true">
          ✳
        </span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section aria-hidden="true" className="overflow-hidden border-y border-line py-6 md:py-8" data-testid="editorial-marquee">
    <div className="marquee-track">
      <Group />
      <Group />
    </div>
  </section>
);
